import api from "../../API/apiConfig";
export const sendEmail = async (emailData) => {
    return await api.post(`email/send`, emailData);
}
export const listAllEmail = async(contactId) => {
    return await api.get(`email/list-log/${contactId}`)
}